module.exports = __webpack_public_path__ + "img/bq.d6da2e84.svg";